export default __webpack_public_path__ + "static/media/south-america.1c081d29.svg";